import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full text-center">
        {/* Illustration SVG 404 */}
        <div className="mb-8">
          <svg
            className="w-full max-w-md mx-auto"
            viewBox="0 0 800 600"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Fond avec étoiles */}
            <circle cx="100" cy="100" r="3" fill="#818CF8" opacity="0.6" />
            <circle cx="700" cy="150" r="2" fill="#A78BFA" opacity="0.6" />
            <circle cx="150" cy="500" r="2" fill="#818CF8" opacity="0.6" />
            <circle cx="650" cy="450" r="3" fill="#A78BFA" opacity="0.6" />
            
            {/* Document perdu */}
            <g transform="translate(250, 150)">
              {/* Papier */}
              <rect x="0" y="0" width="300" height="400" rx="10" fill="white" stroke="#E0E7FF" strokeWidth="4"/>
              <rect x="0" y="0" width="300" height="80" rx="10" fill="#EEF2FF"/>
              
              {/* Lignes du document */}
              <line x1="30" y1="120" x2="270" y2="120" stroke="#C7D2FE" strokeWidth="3" strokeLinecap="round"/>
              <line x1="30" y1="160" x2="270" y2="160" stroke="#C7D2FE" strokeWidth="3" strokeLinecap="round"/>
              <line x1="30" y1="200" x2="200" y2="200" stroke="#C7D2FE" strokeWidth="3" strokeLinecap="round"/>
              
              {/* Point d'interrogation géant */}
              <text x="150" y="320" fontSize="120" fill="#818CF8" fontWeight="bold" textAnchor="middle">?</text>
            </g>
            
            {/* Loupe */}
            <g transform="translate(500, 400)">
              <circle cx="0" cy="0" r="60" fill="none" stroke="#6366F1" strokeWidth="8"/>
              <circle cx="0" cy="0" r="50" fill="#EEF2FF" opacity="0.5"/>
              <line x1="45" y1="45" x2="90" y2="90" stroke="#6366F1" strokeWidth="8" strokeLinecap="round"/>
            </g>
          </svg>
        </div>

        {/* Texte 404 */}
        <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600 mb-4">
          404
        </h1>
        
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Page introuvable
        </h2>
        
        <p className="text-lg text-gray-600 mb-8 max-w-md mx-auto">
          Oups ! La page que vous recherchez semble s'être égarée dans le cyberespace. 
          Elle est peut-être partie prendre un café ☕
        </p>

        {/* Boutons d'action */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={() => navigate('/')}
            className="px-8 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-semibold hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            🏠 Retour à l'accueil
          </button>
          
          <button
            onClick={() => navigate(-1)}
            className="px-8 py-3 bg-white text-indigo-600 rounded-lg font-semibold border-2 border-indigo-600 hover:bg-indigo-50 transition-all duration-200"
          >
            ← Page précédente
          </button>
        </div>

        {/* Message d'aide */}
        <div className="mt-12 p-6 bg-white rounded-xl shadow-md max-w-md mx-auto">
          <p className="text-sm text-gray-600">
            <strong className="text-indigo-600">💡 Besoin d'aide ?</strong><br/>
            Si vous pensez qu'il s'agit d'une erreur, contactez l'administrateur.
          </p>
        </div>
      </div>
    </div>
  );
}
